import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=09664bf2&scoped=true&"
import script from "./UserIcon.vue?vue&type=script&lang=js&"
export * from "./UserIcon.vue?vue&type=script&lang=js&"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=09664bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09664bf2",
  null
  
)

export default component.exports